/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { GeoJSON } from 'ol/format';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import { FeatureLike } from 'ol/Feature';

export class FeatureFormatter {
    public static serialize(features: Feature<Geometry>[]): string {
        const formatter = FeatureFormatter.createFormatter();

        return formatter.writeFeatures(features);
    }

    public static deserialize(features: string): Feature<Geometry>[] {
        const formatter = FeatureFormatter.createFormatter();

        return formatter.readFeatures(features, {
            dataProjection: 'EPSG:3857',
            extent: [0, 0, 0, 0], // unused except for ol.format.MVT
        }) as Feature<Geometry>[];
    }

    private static createFormatter(geometryName?: string) {
        const options = {
            defaultDataProjection: 'EPSG:3857',
            geometryName: 'geometry',
        };
        if (geometryName) {
            options.geometryName = geometryName;
        }
        return new GeoJSON(options);
    }
}
